import { render } from "./AnimatedCharacter.vue?vue&type=template&id=47fc501a"
import script from "./AnimatedCharacter.vue?vue&type=script&lang=js"
export * from "./AnimatedCharacter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__